<script setup lang="ts">

import { FilterDateRange, FiltersBar } from '@shared/ui/filters'
import { MultiSelectSearchable } from '@shared/ui/fields'

import { useDisciplineTaskCommentsFilters } from '../model/task-comments/discipline-task-comments-filters.hook'

defineOptions({
  name: 'DisciplineTaskCommentsFilters',
})

const {
  filterResetKey,
  createdRange,
  disciplineOptions,
  disciplineInitialValue,
  handleDisciplineSelected,
  handleSearch,
  handleClear,
} = useDisciplineTaskCommentsFilters()
</script>

<template>
  <FiltersBar
    class="discipline-task-comments-filters"
    @click:submit="handleSearch"
    @click:clear="handleClear"
  >
    <template #fields>
      <div
        :key="filterResetKey"
        class="discipline-task-comments-filters__general"
      >
        <MultiSelectSearchable
          :key="`discipline-${disciplineOptions.length}`"
          class="multiselect-discipline"
          label="Disciplines"
          placeholder="Select here"
          :options="disciplineOptions"
          :value="disciplineInitialValue"
          :is-all-available="true"
          @selected="handleDisciplineSelected"
        />
        <FilterDateRange
          v-model="createdRange"
          label="Creation date"
          placeholder="Select date"
        />
      </div>
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./DisciplineTaskCommentsFilters.scss" />